import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from "@angular/core";
import { SignChangePipe } from "@modules/core/pipes/sign-change.pipe";

@Directive({
	selector: "[signChanger]",
	standalone: false
})
export class SignChangerDirective implements AfterViewInit {
	protected readonly element: HTMLElement;
	protected defaultSign: string = "*";
	protected defaultTargetSign: string = "-";
	protected signToChange: string;
	protected targetSign: string;

	private pipe: SignChangePipe;

	public constructor(
		protected el: ElementRef,
		protected renderer: Renderer2
	) {
		this.element = el.nativeElement;
		this.pipe = new SignChangePipe();
	}

	@Input()
	public set sign(value: string) {
		if (value.length !== 1) {
			throw Error("Parameter 'sign' should be a single character.");
		}
		this.signToChange = value;
	}

	@Input()
	public set target(value: string) {
		if (value.length !== 1) {
			throw Error("Parameter 'targetSign' should be a single character.");
		}
		this.targetSign = value;
	}

	public ngAfterViewInit(): void {
		this.substituteChars();
	}

	protected substituteChars(): void {
		this.element.innerText = this.pipe.transform(this.element.innerText, [
			this.signToChange || this.defaultSign,
			this.targetSign || this.defaultTargetSign
		]);
	}
}
